import React, { useState, useEffect } from 'react';
import CardCountMetric from '../CardCountMetric';
import api from '../../services/api';
import { notifyApiError } from '../../services/apiError';

const ClientesAtendidos = ({ dtInicial, dtFinal, ...props }) => {
    const [qtdClientes, setQtdClientes] = useState(null);
    const [trendPercent, setTrendPercent] = useState(null);

    const searchInitialData = async () => {
        setQtdClientes(null);

        try {
            const response = await api.get('/relatorios/fazendas/clientes-atendidos', {
                params: { dtInicial, dtFinal },
            })

            setQtdClientes(response.data.data);
            setTrendPercent(response.data.percentage ?? null);

        } catch (error) {
            notifyApiError(error, 'Falha ao carregar clientes atendidos.');
        }
    }

    useEffect(() => {
        searchInitialData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dtInicial, dtFinal])

    return (
        <CardCountMetric
            title="Clientes atendidos"
            value={qtdClientes}
            loading={qtdClientes === null}
            trendPercent={trendPercent}
            trendLabel="vs. período anterior"
            isNew={trendPercent === null && qtdClientes > 0}
            stackTrend
        />
    )
}

export default ClientesAtendidos;
